<template>
  <div>
    <BigGameScore />
  </div>
</template>
<script>
import BigGameScore from './modal/BigGameScore'
export default {
  name: 'MatchLoopScore',
  components: {
    BigGameScore
  },
  created () {
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId)
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/comm/components/MatchLoopScore.vue